export const enum Tasks {
  start = '0',
  checkpoints = '1',
  slipstream = '2',
  finish = '3'
}
